export const GROUPBY_DATE_OPTIONS = [
  { key: 'daily', text: 'Daily', value: 'daily' },
  { key: 'weekly', text: 'Weekly', value: 'weekly' },
  { key: 'monthly', text: 'Monthly', value: 'monthly' },
];

export const defaultChartDimensions = { height: 500, width: 1500 };
